import jsonp from 'jsonp-promise'
import { get } from '../libs/ajax'
import { BJ_URL } from '../constants'
const queryString = require('query-string')
const kmsApiServer = 'https://ffbewotv.dsi.seayoo.com/'
const wrapJsonp = async (url, params) => {
  const { code, data, msg } = await jsonp(
    url + '?' + queryString.stringify(params) + '&t=' + new Date().getTime(),
    { prefix: '__xfe' }
  ).promise
  if (code === 1) {
    return data
  } else {
    return Promise.reject({ code, msg })
  }
}

export function getKMSConfig(url, params) {
  return get(`${kmsApiServer}${url}`, { f: "sn,data", combo: 'y', ...params })
}

export function getTotalNumber(params = {}) {
  return wrapJsonp(
    BJ_URL + '/hyzz/hyzz0710yyz/tally',
    Object.assign(params, {})
  )
}
